<template>
    <!-- Theme one -->

    <div v-if="themeStore.themeIndex === 1">
        <ProfileViewOne :data-set="dataSet" @go-to-path="goToPath" />
    </div>
    <!-- Theme two -->

    <div v-if="themeStore.themeIndex === 2">
        <ProfileViewTwo :data-set="dataSet" @go-to-path="goToPath" />
    </div>
    <!-- Theme three -->
    <div v-if="themeStore.themeIndex === 3">
         <!-- <ProfileViewTwo :data-set="dataSet" @go-to-path="goToPath" /> -->
        <ProfileViewThree :data-set="dataSet" @go-to-path="goToPath" />
    </div>
    <!-- Theme four -->
    <div v-if="themeStore.themeIndex === 4">
        <ProfileViewFour :data-set="dataSet" @go-to-path="goToPath" />
    </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import { useUserStore } from '@/stores/user';
import ProfileViewOne from '@/themes/themeOne/profile/profileView.vue';
import ProfileViewTwo from '@/themes/themeTwo/profile/profileView.vue';
import ProfileViewThree from '@/themes/themeThree/profile/profileView.vue';
import ProfileViewFour from '@/themes/themeFour/profile/profileView.vue';
import { ProfileSettingData } from './supportScript';
import { useThemeStore } from '@/stores/theme';

const router = useRouter()
const userStore = useUserStore()
const themeStore = useThemeStore()
const nickName = computed(() => userStore.nickname)
const loginAccount = computed(() => userStore.loginAccount)
const avatarImg = computed(() => userStore.headimg)

const dataSet = computed<ProfileSettingData>(() => ({
    nickName: nickName.value,
    loginAccount: loginAccount.value,
    avatarImg: avatarImg.value
}))

const goToPath = (path : string) => {
    router.push(path)
}

onMounted(() => {
    userStore.getInfo()
})
</script>
